import React from "react";
import person from "../assets/images/man.png"
import sreejithraj from "../assets/images/sreejithraj1.jpeg"
import diljithraj from "../assets/images/diljithraj.jpeg"
import adithyaraj from "../assets/images/adithyaraj.jpeg"

const CoreTeam = () => {
  return (
    <div id="coreTeam">
      <div className="section section-5 bg-light">
      <div className="container">
        <div className="row justify-content-center text-center mb-5">
          <div className="col-lg-6 mb-5">
            <h2 className="font-weight-bold heading text-primary mb-4">
              Our Core Team
            </h2>
            <p className="text-black-50">
              Behind every blueprint, innovation, and successful project at{" "}
              <strong style={{ color: "#6B83A4" }}>Corbiltek</strong> stands a
              team of passionate minds. With deep roots in design, engineering,
              and technology, our leadership ensures every client experiences
              clarity, transparency, and trust — from concept to completion.
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-4 mb-5 mb-lg-0">
            <div className="h-100 person">
              <img
                src={sreejithraj}
                alt={person}
                style={{width:"80px",height:"80px",borderRadius:"50%"}}
                className="img-fluid"
              />
              <div className="person-contents">
                <h2 className="mb-0"><a href="" className="text-secondary">Sreejithraj C R</a></h2>
                <span className="meta d-block mb-3">MANAGING DIRECTOR</span>
                <p style={{fontSize:"16px"}}>
                  “ Good design shouldn’t be expensive. We’re here to simplify construction and make smart planning accessible to all. ”
                </p>
                <br/>
                <ul className="social list-unstyled list-inline dark-hover">
                  <li className="list-inline-item">
                    <a href=""><span className="icon-twitter"></span></a>
                  </li>
                  <li className="list-inline-item">
                    <a href=""><span className="icon-facebook"></span></a>
                  </li>
                  <li className="list-inline-item">
                    <a href=""><span className="icon-linkedin"></span></a>
                  </li>
                  <li className="list-inline-item">
                    <a href=""><span className="icon-instagram"></span></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4 mb-5 mb-lg-0">
            <div className="h-100 person">
              <img
                src={diljithraj}
                style={{width:"80px",height:"80px",borderRadius:"50%"}}
               alt={person}
                className="img-fluid"
              />
              <div className="person-contents">
                <h2 className="mb-0"><a href="" className="text-secondary">Diljithraj C R</a></h2>
                <span className="meta d-block mb-3">DIRECTOR</span>
                <p style={{fontSize:"16px"}}>
                  “  As a new-age construction startup, we believe in building smarter, faster, and more affordably — redefining how design and construction work together. ”
                </p>
                <ul className="social list-unstyled list-inline dark-hover">
                  <li className="list-inline-item">
                    <a href=""><span className="icon-twitter"></span></a>
                  </li>
                  <li className="list-inline-item">
                    <a href=""><span className="icon-facebook"></span></a>
                  </li>
                  <li className="list-inline-item">
                    <a href=""><span className="icon-linkedin"></span></a>
                  </li>
                  <li className="list-inline-item">
                    <a href=""><span className="icon-instagram"></span></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4 mb-5 mb-lg-0">
            <div className="h-100 person">
              <img
                src={adithyaraj}
                alt={person}
                style={{width:"80px",height:"80px",borderRadius:"50%"}}
                className="img-fluid"
              />
              <div className="person-contents">
                <h2 className="mb-0"><a href="" className="text-secondary">Adithyaraj C P</a></h2>
                <span className="meta d-block mb-3">CHEIF OPERATING OFFICER</span>
                <p style={{fontSize:"16px"}}>
                  “ Our mission is to reduce design costs without compromising quality — helping people turn their dream projects into reality. ”
                </p>
                <br/>
                <ul className="social list-unstyled list-inline dark-hover">
                  <li className="list-inline-item">
                    <a href=""><span className="icon-twitter"></span></a>
                  </li>
                  <li className="list-inline-item">
                    <a href=""><span className="icon-facebook"></span></a>
                  </li>
                  <li className="list-inline-item">
                    <a href=""><span className="icon-linkedin"></span></a>
                  </li>
                  <li className="list-inline-item">
                    <a href=""><span className="icon-instagram"></span></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default CoreTeam;
